import { useEffect, useState } from "react";

const useCountdown = (targetDate: any, serverDate: any) => {
  const targetEndTime = new Date(targetDate).getTime();
  const serverTime = new Date(serverDate).getTime();
  const calculateCountdown = () => Math.max(targetEndTime - serverTime, 0);
  const [countDown, setCountDown] = useState(calculateCountdown());

  useEffect(() => {
    console.log("serverTime:::>", serverTime);
    setCountDown(calculateCountdown());
    const interval = setInterval(() => {
      setCountDown((prevCountDown) => {
        return Math.max(prevCountDown - 1000, 0);
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [targetEndTime, serverTime]);
  return getReturnValues(countDown);
};

const getReturnValues = (countDown: any) => {
  const totalSeconds = Math.floor(countDown / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  let isTimeEnded = countDown <= 0 ? 1 : 0; // Simplified check for time ended
  return [hours, minutes, seconds, isTimeEnded];
};

export { useCountdown };
